import { z } from 'zod';
import { PLACE_INPUT } from '@modules/validation/util/form';

export const enquiryFormSessionSchema = z.object({
    name: z.string().trim().min(1),
    email: z.string().trim().email(),
    phoneNumber: z.string().trim().min(1),
    postcode: z.object({ header: z.string(), value: PLACE_INPUT }),
    branchId: z.number().int().positive().optional(),
    message: z.string().trim().min(1),
    siteTreeId: z.number().int().positive(),
    source: z.enum([
        'InPage',
        'EnquiryModal',
        'ProfessionalIsland',
        'ProductIsland',
        'ProjectIsland',
        'ProjectTeam',
        'ProjectDetail',
    ]),
    professional: z.object({
        ID: z.number().int().positive(),
        Title: z.string(),
    }),
    itemType: z.enum(['professional', 'product', 'project', 'article']),
    relatedItem: z
        .object({
            id: z.number().int().positive(),
            type: z.enum(['project']),
            title: z.string(),
            category: z.string(),
        })
        .optional(),
    files: z
        .array(
            z.object({
                name: z.string(),
                type: z.string(),
                size: z.number(),
                lastModified: z.number(),
            })
        )
        .optional(),
    isModal: z.boolean().default(false),
});
